<div class="sitePanelExpandAll" (click)="toggleExpandAll()">
  <pp-icon
    class="buttonDropdown__icon"
    ppColor="inherit"
    [ppSVG]="
      allCollapsed
        ? iconMap[EIconPath.ICON_TABLE_EXPAND_ALL]
        : iconMap[EIconPath.ICON_TABLE_COLLAPSE_ALL]
    "
  />

  <span class="buttonDropdown__text">
    {{ (allCollapsed ? 'expand_all' : 'collapse_all') | ppTranslate }}
  </span>
</div>
